import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sale-box__segment-head" }
const _hoisted_2 = { class: "sale-box__ratings" }
const _hoisted_3 = { class: "sale-box__ratings-wrapper" }
const _hoisted_4 = { class: "sale-box__ratings-count" }
const _hoisted_5 = {
  key: 0,
  class: "sale-box__ratings-count"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "sale-box__headline" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "sale-box__product-name" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ratings = _resolveComponent("ratings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ratings, {
          rating: _ctx.productDetails.product.reviewsAverage,
          href: "#reviewForm",
          type: "disabled"
        }, null, 8 /* PROPS */, ["rating"]),
        _cache[5] || (_cache[5] = _createTextVNode()),
        (_ctx.productDetails.product.reviewsRecommendationPercentage >= _ctx.minRecoPercentage && _ctx.productDetails.product.reviewsCount >= 5)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('ads.main.head.reviews.rating.count', [_ctx.productDetails.product.reviewsCount])), 1 /* TEXT */),
              _cache[3] || (_cache[3] = _createTextVNode()),
              _createElementVNode("a", {
                href: "#reviewForm",
                class: "sale-box__ratings-percentage",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('rateNowClicked')), ["prevent"]))
              }, _toDisplayString(_ctx.$t('ads.main.head.reviews.rating.percentage', [_ctx.productDetails.product.reviewsRecommendationPercentage])), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.productDetails.product.reviewsCount > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('ads.main.head.reviews.rating.count', [_ctx.productDetails.product.reviewsCount])), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _cache[4] || (_cache[4] = _createTextVNode()),
              _createElementVNode("a", {
                href: "#reviewForm",
                class: "sale-box__ratings-link",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('rateNowClicked')), ["prevent"]))
              }, _toDisplayString(_ctx.$t(_ctx.productHasCurrentUsersReview ? 'ads.main.head.reviews.rating.rated' : 'ads.main.head.reviews.rating.rate_now')), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */)),
        _cache[6] || (_cache[6] = _createTextVNode()),
        _createElementVNode("span", {
          class: "sale-box__sale-unit",
          innerHTML: _ctx.productDetails.product.offerHtml
        }, null, 8 /* PROPS */, _hoisted_6)
      ])
    ]),
    _cache[10] || (_cache[10] = _createTextVNode()),
    _createElementVNode("h1", _hoisted_7, [
      (_ctx.productDetails.product.vintage)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "sale-box__vintage",
            innerHTML: _ctx.productDetails.product.vintage
          }, null, 8 /* PROPS */, _hoisted_8))
        : _createCommentVNode("v-if", true),
      _cache[7] || (_cache[7] = _createTextVNode()),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.productDetails.product.description1), 1 /* TEXT */),
      _cache[8] || (_cache[8] = _createTextVNode()),
      (_ctx.productDetails.product.description2)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "sale-box__short-description",
            innerHTML: _ctx.productDetails.product.description2
          }, null, 8 /* PROPS */, _hoisted_10))
        : _createCommentVNode("v-if", true),
      _cache[9] || (_cache[9] = _createTextVNode()),
      (_ctx.productDetails.product.description3)
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: "sale-box__short-description",
            innerHTML: _ctx.productDetails.product.description3
          }, null, 8 /* PROPS */, _hoisted_11))
        : _createCommentVNode("v-if", true)
    ]),
    _cache[11] || (_cache[11] = _createTextVNode()),
    (!_ctx.productDetails.product.zeroPriceItem && !_ctx.productDetails.product.recurringOrderFollowUpPacket)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["sale-box__button-wishlist", {
        'sale-box__button-wishlist--filled': _ctx.productDetails.product.inWishlist,
        'sale-box__button-wishlist--loading': _ctx.state === 'loadingWishlist',
        'sale-box__button-wishlist--top-right': !_ctx.productDetails.product.vintage
      }]),
          type: "button",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('wishlistClicked')), ["prevent"]))
        }, null, 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ]))
}